import { ErrorBaseData } from '.'

export const physicianAddressErrors: Record<string, ErrorBaseData> = {
  PhysicianAddressNotFoundException: {
    message: 'Endereço mádico não encontrado',
    description: 'Não foi possível encontrar o endereço médico. Verifique as informações e tente novamente',
  },
  PhysicianAddressAlreadyExistsException: {
    message: 'Endereço médico já cadastrado',
    description: 'Este endereço médico já foi cadastrado. Verifique as informações e tente novamente',
  },
}
